(() => {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;
  if (window.__joaApoReadinessInstalled) return;
  window.__joaApoReadinessInstalled = true;

  const ACTION_SELECTOR = [
    '.joa-sticky-purchase',
    '.joa-product-form .mw-apo-add-to-cart-cloned',
    '.joa-product-form button[data-testid="standalone-add-to-cart"]',
    '.joa-product-form button[name="add"].add-to-cart-button',
    '.sticky-add-to-cart__button'
  ].join(',');

  const OPTION_CONTROL_SELECTOR = [
    '.mw-option__control',
    'input',
    'select',
    'button'
  ].join(',');

  function optionContainer() {
    return [...document.querySelectorAll('.mw-apo-container')].find(
      (container) =>
        !container.closest('.joa-express-form') &&
        container.querySelector('[name^="mw_opts["]')
    ) || null;
  }

  function apoIsReady() {
    const container = optionContainer();
    if (!container) return false;

    const groups = [...container.querySelectorAll(':scope > .mw-option')];
    if (!groups.length) return false;

    return groups.every((group) => group.querySelector(OPTION_CONTROL_SELECTOR));
  }

  function readinessState() {
    const html = document.documentElement;
    if (html.classList.contains('joa-express-active')) {
      return apoIsReady() ? 'ready' : 'loading';
    }
    return html.classList.contains('joa-express-booting')
      ? 'loading'
      : 'not-applicable';
  }

  function syncReadiness() {
    const state = readinessState();
    const loading = state === 'loading';
    document.body?.classList.toggle('joa-options-are-loading', loading);
    document.body?.classList.toggle('joa-options-are-ready', !loading);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(ACTION_SELECTOR);
    if (!button || readinessState() !== 'loading') return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  const observer = new MutationObserver(syncReadiness);
  observer.observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });

  document.addEventListener('joa:apo-statechange', syncReadiness);
  document.addEventListener('DOMContentLoaded', syncReadiness, { once: true });
  window.addEventListener('pageshow', syncReadiness);
  syncReadiness();
})();
